module.exports = __webpack_public_path__ + "static/MOE-551ba9719ebe3e0aab5f6ced07c20e35.png";